import { Download } from "@mui/icons-material";
import {
  Card,
  Table,
  Button,
  Select,
  MenuItem,
  TableRow,
  TableBody,
  TableHead
} from "@mui/material";
// GLOBAL CUSTOM COMPONENTS
import { FlexBetween } from "app/components/FlexBox";
import { H5 } from "app/components/Typography";
//STYLED COMPONENTS
import { BodyTableCell, HeadTableCell } from "./common/styles";

export default function Statements() {
  return (
    <Card sx={{ pb: 2 }}>
      <FlexBetween px={3} py={2}>
        <H5>Statement</H5>

        <Select value="2021" onChange={() => { }}>
          <MenuItem value="2021">2021</MenuItem>
          <MenuItem value="2020">2020</MenuItem>
          <MenuItem value="2019">2019</MenuItem>
        </Select>
      </FlexBetween>

      <Table sx={{ minWidth: 800 }}>
        <TableHead sx={{ backgroundColor: "grey.100" }}>
          <TableRow>
            <HeadTableCell>Date</HeadTableCell>
            <HeadTableCell>Order ID</HeadTableCell>
            <HeadTableCell>Order Details</HeadTableCell>
            <HeadTableCell>Amount</HeadTableCell>
            <HeadTableCell>Invoice</HeadTableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {[1, 2, 3, 4, 5, 6].map((item) => (
            <TableRow key={item}>
              <BodyTableCell>Nov 12, 2021</BodyTableCell>
              <BodyTableCell>202745788</BodyTableCell>
              <BodyTableCell>The Icon of full icon set</BodyTableCell>
              <BodyTableCell>$650</BodyTableCell>
              <BodyTableCell>
                <Button variant="contained" disabled={item === 1} startIcon={<Download />}>
                  Download
                </Button>
              </BodyTableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Card>
  );
}
